import { render, staticRenderFns } from "./HistoryExport.vue?vue&type=template&id=0018b0a2&scoped=true"
import script from "./HistoryExport.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryExport.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HistoryExport.vue?vue&type=style&index=0&id=0018b0a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0018b0a2",
  null
  
)

export default component.exports